/* src/components/landing/LpCta.jsx */
import React from 'react';
import { Link } from 'react-router-dom';

export default function LpCta({ addReveal, revealStyle, btnPrimary, btnLarge }) {
  const btnWhite = { ...btnPrimary, background: '#fff', color: 'var(--primary)', ...btnLarge };
  const btnGhost = { ...btnPrimary, background: 'transparent', color: '#fff', border: '1.5px solid rgba(255,255,255,0.2)', ...btnLarge };

  return (
    <section className="s-pad" style={{ padding: '120px 0' }}>
      <div className="container">
        <div ref={addReveal} className="cta-box" style={{ ...revealStyle, background: 'var(--primary)', borderRadius: 24, padding: '80px 60px', textAlign: 'center', color: '#fff', position: 'relative', overflow: 'hidden' }}>
          <div style={{ position: 'absolute', top: -100, right: -100, width: 400, height: 400, background: 'radial-gradient(circle, rgba(0,214,143,0.08) 0%, transparent 60%)', pointerEvents: 'none' }} />
          <h2 className="serif s-title" style={{ fontSize: '2.8rem', marginBottom: 16, position: 'relative', color: '#fff' }}>Pronto para fechar mais contratos?</h2>
          <p style={{ color: 'rgba(255,255,255,0.6)', fontSize: '1.1rem', maxWidth: 500, margin: '0 auto 36px', position: 'relative' }}>Comece agora com 7 dias grátis. Sem cartão de crédito. Sem compromisso.</p>
          <div className="cta-btns" style={{ display: 'flex', justifyContent: 'center', gap: 16, position: 'relative' }}>
            <Link to={`https://wa.me/5561991826667?text=${encodeURIComponent('Começar grátis')}`} target="_blank" rel="noopener noreferrer" style={btnWhite}>Começar grátis</Link>
            <Link to={`https://wa.me/5561991826667?text=${encodeURIComponent('Agendar demonstração')}`} target="_blank" rel="noopener noreferrer" style={btnGhost}>Agendar demonstração</Link>
          </div>
        </div>
      </div>
    </section>
  );
}
